import { css } from '@emotion/react';

export const plain = css`
  display: inline-block;
  vertical-align: middle;
`;
